<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-ums__integrationcharge">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item v-if="visible">
                    <el-select v-model="dataForm.orgId" placeholder="请选择区域">
                        <el-option label="全选" value="" key=""></el-option>
                        <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.orgName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="dataForm.operatType" placeholder="请选择收益状态">
                        <el-option
                                v-for="item in allStatus"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.mobileNumber" placeholder="会员电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.deviceCode" placeholder="设备编码" clearable></el-input>
                </el-form-item>
                <!--        <el-form-item>-->
                <!--          <el-select v-model="dataForm.changeType" placeholder="改变类型">-->
                <!--            <el-option-->
                <!--                v-for="item in changeTypes"-->
                <!--                :key="item.value"-->
                <!--                :label="item.lable"-->
                <!--                :value="item.value">-->
                <!--            </el-option>-->
                <!--          </el-select>-->
                <!--        </el-form-item>-->
                <!--        <el-form-item>-->
                <!--          <el-select v-model="dataForm.operatType" placeholder="操作类型">-->
                <!--            <el-option-->
                <!--              v-for="item in operatTypes"-->
                <!--              :key="item.value"-->
                <!--              :label="item.lable"-->
                <!--              :value="item.value">-->
                <!--            </el-option>-->
                <!--          </el-select>-->
                <!--        </el-form-item>-->
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.beginDate"
                                    type="date"
                                    :clearable="false"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd"
                                    :editable="false"
                                    :picker-options="pickerOptions"

                                    placeholder="开始时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.endDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd"
                                    placeholder="结束时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
                </el-form-item>
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('ums:integrationcharge:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
                <!--        </el-form-item>-->
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('ums:integrationcharge:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
                <!--        </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <!--        <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="orgName" label="公司名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobileNumber" label="会员电话号" header-align="center"
                                 align="center"></el-table-column>
                <!--        <el-table-column prop="operatType" label="操作类型" header-align="center" align="center">-->
                <!--          <template slot-scope="scope">-->
                <!--            <el-tag v-if="scope.row.operatType===0" type="success" size="small">设备释放优果</el-tag>-->
                <!--          </template>-->
                <!--        </el-table-column>-->
                <el-table-column prop="balanceType" label="优果类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.balanceType===2" size="small" type="success">赠送优果</el-tag>
                        <el-tag v-else-if="scope.row.changeType===6" size="small" type="success">红果</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="changeType" label="改变类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.changeType===1" size="small" type="success">增加</el-tag>
                        <el-tag v-else-if="scope.row.changeType===2" size="small" type="success">减少</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="changeNumber" label="优果改变数量" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="deviceCode" label="设备码" header-align="center" align="center"></el-table-column>
                <!--        <el-table-column prop="balance" label="余额" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="note" label="流水备注" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="deptId" label="部门ID" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
                <!--        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">-->
                <!--          <template slot-scope="scope">-->
                <!--            <el-button v-if="$hasPermission('ums:integrationcharge:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>-->
                <!--            <el-button v-if="$hasPermission('ums:integrationcharge:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
                <!--          </template>-->
                <!--        </el-table-column>-->
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './integrationcharge-add-or-update'

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                visible: false,
                orgList: [],
                mixinViewModuleOptions: {
                    getDataListURL: '/ums/integrationcharge/page',
                    getDataListIsPage: true,
                    exportURL: '/ums/integrationcharge/export',
                    deleteURL: '/ums/integrationcharge',
                    deleteIsBatch: true,
                    activatedIsNeed: false
                },
                pickerOptions:{
                    //禁用当前日期之前的日期
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 86400000*31;
                    }
                },
                allStatus: [{
                    value: '',
                    label: ''
                }, {
                    value: 1,
                    label: '设备产生赠送您优果'
                }, {
                    value: 2,
                    label: '分享红果收益'
                }],
                changeTypes: [{
                    value: '1',
                    label: '增加'
                }, {
                    value: '2',
                    label: '减少'
                }],
                dataForm: {
                    beginDate: "",
                    endDate:"",
                    memberId: '',
                    operatType: '',
                    changeType: '',
                    mobileNumber: "",
                    memberName: '',
                    orgId: '',
                    orgName:'',
                    isHead:false,
                    deviceCode:""
                }
            }

        },
        created() {
            let d = new Date
            d.setDate(d.getDate()-1);
            //d.setTime(d.getTime()-24*30*60*60*1000);
            d.setHours(0);
            d.setMinutes(0);
            d.setSeconds(0);
            d.setMilliseconds(0)
            this.dataForm.beginDate=d
        },
        mounted() {
            const that = this;
            that.getInfo();
        },
        methods:{
            dateChange(){
                let _this=this;
                this.pickerOptions={ //日期禁用
                    disabledDate(date) {
                        return date.getTime() < new Date(_this.dataForm.endDate).getTime() - 86400000;
                    }
                }
                if(this.dataForm.enactDateEnd){
                    let enactDateBeginText=new Date(this.dataForm.beginDate).getTime();
                    let enactDateEndText=new Date(this.dataForm.enactDateEnd).getTime();
                    if(enactDateBeginText>enactDateEndText){
                        this.dataForm.enactDateEnd='';
                    }
                }
            },
            getInfo() {
                this.$http.get(`/sys/user/info`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.orgId=res.data.orgId
                    this.dataForm.orgName=res.data.orgName
                    this.dataForm.isHead=res.data.isHead;
                    if (this.dataForm.isHead) {
                        this.visible=true;
                        this.getOrgList();
                    }
                    if(!this.mixinViewModuleOptions.activatedIsNeed){
                        this.getDataList()
                    }
                }).catch(() => {
                })
            },
            // 获取部门列表
            getOrgList() {
                return this.$http.get('/sys/org/select').then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.orgList = res.data
                }).catch(() => {
                })
            }
        },
        components: {
            AddOrUpdate
        }
    }
</script>
